// Вкладки карточки ЗАЯВКИ (просмотр: Работы, Продукты, Доп. работы, Себестоимость), перенесённые из Office.
// Формат — см. request.js. Права-вкладки: office_api/office_port/areas/requests/ep_cr_read.py (TAB_GRANTS).
import { defineAsyncComponent } from "vue";

export const tabsCodes = {
  OA__RemontFormOfficeWorkSmetaTab: "crrWorks",
  OA__RemontFormOfficeProductsTab: "crrProducts",
  OA__RemontFormOfficeOptionWorkTab: "crrOptionWorks",
  OA__RemontFormOfficeSebesFixTab: "crrSebes",
};

export const components = {
  crrWorks: defineAsyncComponent(() => import("./crrWorks/index.vue")),
  crrProducts: defineAsyncComponent(() => import("./crrProducts/index.vue")),
  crrOptionWorks: defineAsyncComponent(() => import("./crrOptionWorks/index.vue")),
  crrSebes: defineAsyncComponent(() => import("./crrSebes/index.vue")),
};

export const groups = {
  contract: ["crrProducts", "crrOptionWorks"],
  materials: ["crrWorks", "crrSebes"],
};

export const aliases = {
  crrWorks: "работы смета работ тариф подрядчик",
  crrProducts: "продукты техника мебель кухня умный дом ковры освещение заявка на продукты сервисное обслуживание",
  crrOptionWorks: "доп работы опции дс",
  crrSebes: "себестоимость фиксация сметы работы * сравнение",
};
